export { default as MassScheduleDialog } from './MassScheduleDialog';
export { default as ReconciliationScheduleDialog } from './ReconciliationScheduleDialog';
export { default as AdorationScheduleDialog } from './AdorationScheduleDialog';
export { default as DioceseSearchSelect } from './DioceseSearchSelect';

export const LITURGY_TYPES = ["Novus Ordo", "Traditional Latin Mass (TLM)", "Byzantine", "Maronite", "Ordinariate", "Other"];
export const DAYS_OF_WEEK = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Daily"];
export const LANGUAGES = ["English", "Spanish", "Latin", "Polish", "Vietnamese", "Filipino", "Other"];
export const RITES = [
  "Roman Rite",
  "Eastern Rites/Alexandrian",
  "Eastern Rites/Antiochian",
  "Eastern Rites/Armenian",
  "Eastern Rites/Chaldean",
  "Eastern Rites/Byzantine"
];
